import request from '@/services/request';

export const updateUserProfile = data => request.put('/profile', data);

export const deleteUserData = () => request.delete('/profile');

export const validateUsername = username => request.get(`/profile/validate-username/${username}`);

export const setSocials = payload => request.post('/profile/socials', payload);

export const getSocials = () => request.get('/profile/socials');

export const getSocialsPublic = userId => request.get(`/profile/socials/${userId}`);

export const getContent = userId => request.get(`/profile/content/${userId}`);

export const verify = userId => request.put(`/profile/${userId}/verify`);

export const removeVerification = userId => request.put(`/profile/${userId}/remove-verification`);

export const getPublicLinks = userId => request.get(`/profile/${userId}/links`);

export const updateOptions = (userId, data) => request.put(`/profile/${userId}/options`, data);
